/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Impero API
 * Legacy Impero .NET API (served under /v1).
 */
import { useMutation, useQuery, useSuspenseQuery } from "@tanstack/react-query";
import type {
    DataTag,
    DefinedInitialDataOptions,
    DefinedUseQueryResult,
    MutationFunction,
    QueryClient,
    QueryFunction,
    QueryKey,
    UndefinedInitialDataOptions,
    UseMutationOptions,
    UseMutationResult,
    UseQueryOptions,
    UseQueryResult,
    UseSuspenseQueryOptions,
    UseSuspenseQueryResult,
} from "@tanstack/react-query";

import axios from "axios";
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";

import type {
    LegacyReportList,
    LegacySavedReportUsers,
    LegacyUpdateClassificationAccessRightsViewModel,
} from "../model";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

const withQueryKey = <T extends object, K>(
    query: T,
    queryKey: K
): T & { queryKey: K } => {
    const result = { queryKey } as T & { queryKey: K };
    for (const key of Object.keys(query)) {
        // The explicit queryKey always wins, matching the previous
        // `{ ...query, queryKey }` spread where it was set last.
        if (key === "queryKey") continue;
        Object.defineProperty(result, key, {
            enumerable: true,
            configurable: true,
            get: () => (query as Record<string, unknown>)[key],
        });
    }
    return result;
};

export const legacyReportIndex = (
    options?: AxiosRequestConfig
): Promise<AxiosResponse<LegacyReportList>> => {
    return axios.get(`/v1/Report/All`, options);
};

export const getLegacyReportIndexQueryKey = () => {
    return [`/v1/Report/All`] as const;
};

export const getLegacyReportIndexQueryOptions = <
    TData = Awaited<ReturnType<typeof legacyReportIndex>>,
    TError = AxiosError<unknown>,
>(options?: {
    query?: Partial<
        UseQueryOptions<
            Awaited<ReturnType<typeof legacyReportIndex>>,
            TError,
            TData
        >
    >;
    axios?: AxiosRequestConfig;
}) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getLegacyReportIndexQueryKey();

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof legacyReportIndex>>
    > = ({ signal }) => legacyReportIndex({ signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof legacyReportIndex>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type LegacyReportIndexQueryResult = NonNullable<
    Awaited<ReturnType<typeof legacyReportIndex>>
>;
export type LegacyReportIndexQueryError = AxiosError<unknown>;

export function useLegacyReportIndex<
    TData = Awaited<ReturnType<typeof legacyReportIndex>>,
    TError = AxiosError<unknown>,
>(
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof legacyReportIndex>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof legacyReportIndex>>,
                    TError,
                    Awaited<ReturnType<typeof legacyReportIndex>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useLegacyReportIndex<
    TData = Awaited<ReturnType<typeof legacyReportIndex>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof legacyReportIndex>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof legacyReportIndex>>,
                    TError,
                    Awaited<ReturnType<typeof legacyReportIndex>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useLegacyReportIndex<
    TData = Awaited<ReturnType<typeof legacyReportIndex>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof legacyReportIndex>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useLegacyReportIndex<
    TData = Awaited<ReturnType<typeof legacyReportIndex>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof legacyReportIndex>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getLegacyReportIndexQueryOptions(options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getLegacyReportIndexSuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof legacyReportIndex>>,
    TError = AxiosError<unknown>,
>(options?: {
    query?: Partial<
        UseSuspenseQueryOptions<
            Awaited<ReturnType<typeof legacyReportIndex>>,
            TError,
            TData
        >
    >;
    axios?: AxiosRequestConfig;
}) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getLegacyReportIndexQueryKey();

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof legacyReportIndex>>
    > = ({ signal }) => legacyReportIndex({ signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof legacyReportIndex>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type LegacyReportIndexSuspenseQueryResult = NonNullable<
    Awaited<ReturnType<typeof legacyReportIndex>>
>;
export type LegacyReportIndexSuspenseQueryError = AxiosError<unknown>;

export function useLegacyReportIndexSuspense<
    TData = Awaited<ReturnType<typeof legacyReportIndex>>,
    TError = AxiosError<unknown>,
>(
    options: {
        query: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof legacyReportIndex>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useLegacyReportIndexSuspense<
    TData = Awaited<ReturnType<typeof legacyReportIndex>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof legacyReportIndex>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useLegacyReportIndexSuspense<
    TData = Awaited<ReturnType<typeof legacyReportIndex>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof legacyReportIndex>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useLegacyReportIndexSuspense<
    TData = Awaited<ReturnType<typeof legacyReportIndex>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof legacyReportIndex>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getLegacyReportIndexSuspenseQueryOptions(options);

    const query = useSuspenseQuery(
        queryOptions,
        queryClient
    ) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const legacyReportDeleteSavedControlResultStatus = (
    id: string,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<void>> => {
    return axios.post(
        `/v1/Report/ControlResultStatus/Saved/Delete/${id}`,
        undefined,
        options
    );
};

export const getLegacyReportDeleteSavedControlResultStatusMutationOptions = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof legacyReportDeleteSavedControlResultStatus>>,
        TError,
        { id: string },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof legacyReportDeleteSavedControlResultStatus>>,
    TError,
    { id: string },
    TContext
> => {
    const mutationKey = ["legacyReportDeleteSavedControlResultStatus"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof legacyReportDeleteSavedControlResultStatus>>,
        { id: string }
    > = (props) => {
        const { id } = props ?? {};

        return legacyReportDeleteSavedControlResultStatus(id, axiosOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type LegacyReportDeleteSavedControlResultStatusMutationResult =
    NonNullable<
        Awaited<ReturnType<typeof legacyReportDeleteSavedControlResultStatus>>
    >;

export type LegacyReportDeleteSavedControlResultStatusMutationError =
    AxiosError<unknown>;

export const useLegacyReportDeleteSavedControlResultStatus = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<
                ReturnType<typeof legacyReportDeleteSavedControlResultStatus>
            >,
            TError,
            { id: string },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof legacyReportDeleteSavedControlResultStatus>>,
    TError,
    { id: string },
    TContext
> => {
    return useMutation(
        getLegacyReportDeleteSavedControlResultStatusMutationOptions(options),
        queryClient
    );
};
export const legacyReportEditAccessRights = (
    id: string,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<LegacySavedReportUsers>> => {
    return axios.get(
        `/v1/Report/ControlResultStatus/Saved/EditAccessRights/${id}`,
        options
    );
};

export const getLegacyReportEditAccessRightsQueryKey = (id: string) => {
    return [
        `/v1/Report/ControlResultStatus/Saved/EditAccessRights/${id}`,
    ] as const;
};

export const getLegacyReportEditAccessRightsQueryOptions = <
    TData = Awaited<ReturnType<typeof legacyReportEditAccessRights>>,
    TError = AxiosError<unknown>,
>(
    id: string,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof legacyReportEditAccessRights>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getLegacyReportEditAccessRightsQueryKey(id);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof legacyReportEditAccessRights>>
    > = ({ signal }) =>
        legacyReportEditAccessRights(id, { signal, ...axiosOptions });

    return {
        queryKey,
        queryFn,
        enabled: id !== null && id !== undefined,
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<ReturnType<typeof legacyReportEditAccessRights>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type LegacyReportEditAccessRightsQueryResult = NonNullable<
    Awaited<ReturnType<typeof legacyReportEditAccessRights>>
>;
export type LegacyReportEditAccessRightsQueryError = AxiosError<unknown>;

export function useLegacyReportEditAccessRights<
    TData = Awaited<ReturnType<typeof legacyReportEditAccessRights>>,
    TError = AxiosError<unknown>,
>(
    id: string,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof legacyReportEditAccessRights>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof legacyReportEditAccessRights>>,
                    TError,
                    Awaited<ReturnType<typeof legacyReportEditAccessRights>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useLegacyReportEditAccessRights<
    TData = Awaited<ReturnType<typeof legacyReportEditAccessRights>>,
    TError = AxiosError<unknown>,
>(
    id: string,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof legacyReportEditAccessRights>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof legacyReportEditAccessRights>>,
                    TError,
                    Awaited<ReturnType<typeof legacyReportEditAccessRights>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useLegacyReportEditAccessRights<
    TData = Awaited<ReturnType<typeof legacyReportEditAccessRights>>,
    TError = AxiosError<unknown>,
>(
    id: string,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof legacyReportEditAccessRights>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useLegacyReportEditAccessRights<
    TData = Awaited<ReturnType<typeof legacyReportEditAccessRights>>,
    TError = AxiosError<unknown>,
>(
    id: string,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof legacyReportEditAccessRights>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getLegacyReportEditAccessRightsQueryOptions(
        id,
        options
    );

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getLegacyReportEditAccessRightsSuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof legacyReportEditAccessRights>>,
    TError = AxiosError<unknown>,
>(
    id: string,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof legacyReportEditAccessRights>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getLegacyReportEditAccessRightsQueryKey(id);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof legacyReportEditAccessRights>>
    > = ({ signal }) =>
        legacyReportEditAccessRights(id, { signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof legacyReportEditAccessRights>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type LegacyReportEditAccessRightsSuspenseQueryResult = NonNullable<
    Awaited<ReturnType<typeof legacyReportEditAccessRights>>
>;
export type LegacyReportEditAccessRightsSuspenseQueryError =
    AxiosError<unknown>;

export function useLegacyReportEditAccessRightsSuspense<
    TData = Awaited<ReturnType<typeof legacyReportEditAccessRights>>,
    TError = AxiosError<unknown>,
>(
    id: string,
    options: {
        query: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof legacyReportEditAccessRights>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useLegacyReportEditAccessRightsSuspense<
    TData = Awaited<ReturnType<typeof legacyReportEditAccessRights>>,
    TError = AxiosError<unknown>,
>(
    id: string,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof legacyReportEditAccessRights>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useLegacyReportEditAccessRightsSuspense<
    TData = Awaited<ReturnType<typeof legacyReportEditAccessRights>>,
    TError = AxiosError<unknown>,
>(
    id: string,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof legacyReportEditAccessRights>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useLegacyReportEditAccessRightsSuspense<
    TData = Awaited<ReturnType<typeof legacyReportEditAccessRights>>,
    TError = AxiosError<unknown>,
>(
    id: string,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof legacyReportEditAccessRights>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getLegacyReportEditAccessRightsSuspenseQueryOptions(
        id,
        options
    );

    const query = useSuspenseQuery(
        queryOptions,
        queryClient
    ) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const legacyReportUpdateAccessRights = (
    id: string,
    legacyUpdateClassificationAccessRightsViewModel?: LegacyUpdateClassificationAccessRightsViewModel,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<void>> => {
    return axios.post(
        `/v1/Report/ControlResultStatus/Saved/EditAccessRights/${id}`,
        legacyUpdateClassificationAccessRightsViewModel,
        options
    );
};

export const getLegacyReportUpdateAccessRightsMutationOptions = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof legacyReportUpdateAccessRights>>,
        TError,
        { id: string; data?: LegacyUpdateClassificationAccessRightsViewModel },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof legacyReportUpdateAccessRights>>,
    TError,
    { id: string; data?: LegacyUpdateClassificationAccessRightsViewModel },
    TContext
> => {
    const mutationKey = ["legacyReportUpdateAccessRights"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof legacyReportUpdateAccessRights>>,
        { id: string; data?: LegacyUpdateClassificationAccessRightsViewModel }
    > = (props) => {
        const { id, data } = props ?? {};

        return legacyReportUpdateAccessRights(id, data, axiosOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type LegacyReportUpdateAccessRightsMutationResult = NonNullable<
    Awaited<ReturnType<typeof legacyReportUpdateAccessRights>>
>;
export type LegacyReportUpdateAccessRightsMutationBody =
    | LegacyUpdateClassificationAccessRightsViewModel
    | undefined;
export type LegacyReportUpdateAccessRightsMutationError = AxiosError<unknown>;

export const useLegacyReportUpdateAccessRights = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof legacyReportUpdateAccessRights>>,
            TError,
            {
                id: string;
                data?: LegacyUpdateClassificationAccessRightsViewModel;
            },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof legacyReportUpdateAccessRights>>,
    TError,
    { id: string; data?: LegacyUpdateClassificationAccessRightsViewModel },
    TContext
> => {
    return useMutation(
        getLegacyReportUpdateAccessRightsMutationOptions(options),
        queryClient
    );
};
